<template>
  <w-icon-wrapper
    :height='21.47'
    :width='24'
    icon-name='work-revert-archived-icon'
    view-box='0 0 24 21.47'
  >
    <g
      id="_118_Archiv_Rückgängig_Icon"
      data-name="118_Archiv_Rückgängig_Icon"
      transform="translate(-7270.47 -2918)"
    >
      <path
        id="Pfad_59721"
        data-name="Pfad 59721"
        d="M40.34,1.355a5.9,5.9,0,0,1,.97,2H52.38V5.7H41.5a5.922,5.922,0,0,1-.58,2H50.5v13.13H34.25v-9.74a5.79,5.79,0,0,1-2-.73v12.47H52.5V7.7h1.88V1.355Z"
        transform="translate(7240 2918)"
        fill="currentColor"
      />
      <path
        id="Pfad_59722"
        data-name="Pfad 59722"
        d="M45.433,14.445H39.308a1,1,0,0,1,0-2h6.125a1,1,0,0,1,0,2"
        transform="translate(7240 2918)"
        fill="currentColor"
      />
      <path
        id="Pfad_59723"
        data-name="Pfad 59723"
        d="M40.3,4.972a4.983,4.983,0,0,1-.77,2.66,4.932,4.932,0,0,1-3.1,2.19,4.674,4.674,0,0,1-1.11.13,4.986,4.986,0,0,1-4.84-3.88.5.5,0,0,1,.06-.38.474.474,0,0,1,.32-.22.491.491,0,0,1,.6.38,3.963,3.963,0,1,0,2.99-4.74,3.813,3.813,0,0,0-1.62.79h.4a.5.5,0,0,1,.5.51.5.5,0,0,1-.5.5h-2.22V.7a.51.51,0,0,1,1.02,0v.56a4.789,4.789,0,0,1,1.45-.91,5.371,5.371,0,0,1,.75-.23,4.99,4.99,0,0,1,5.95,3.75,5.217,5.217,0,0,1,.12,1.1"
        transform="translate(7240 2918)"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>
  
  <script>
  export default { name: 'WorkIconRevertArchived' };
  </script>
  